import './style.scss';
import { Link } from "react-router-dom";

function App() {
  return (
   <header className="mc-header2">
      <section className="mc-header2__strip">
        <div>
          <div className="mc-header2__menu-mobile-wrap">
            <div className="menu-m">          
              <Link to="/">
                <img src="/images/mc-white.png" />
              </Link>
            </div> 
          </div>
          <div className="mc-header2__menu-wrap">
            <div className="menu menu-1">          
              <Link to="/the-film">
                THE FILM
              </Link>
            </div>          
            <div className="menu menu-x">          
              <Link to="/">
                <img src="/images/mc-white.png" />
              </Link>
            </div>    
            <div className="menu menu-2">
              <Link to="/original-score">
                ORIGINAL SCORE
              </Link>
            </div>         
          </div>
        </div>
      </section>
    </header>
  );
}

export default App;


